import styled from "styled-components";
import { Colors } from "../../config/Constants";
const downArrow = require("../../assets/images/VectorDownArrow.png");

interface Props {
  onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  label?: string;
  value?: string;
  data: {
    flag: any;
    name: string;
    alpha2Code: string;
    callingCode: string;
  }[];
  name: string;
  required: boolean;
  helperText: string;
  disabled?: boolean;
  // setImage: (a: any) => void;
}

const DropdownWithImage = ({
  onChange,
  label,
  value,
  data,
  name,
  required,
  disabled,
}: // setImage,
Props) => {
  const handleChange = (e: any) => {
    onChange(e);
    // console.log(e);
    // let imageObj = data.find((eachData) => {
    //   return eachData.callingCode === e.target.value;
    // });
    // //@ts-ignore
    // setImage(imageObj.flag);
  };
  return (
    <>
      <InputFieldWrapper>
        {label && (
          <Label>
            {label}
            {required && <span>*</span>}
          </Label>
        )}
        <Select
          disabled={disabled}
          onChange={handleChange}
          value={value}
          name={name}
        >
          {data.map(
            (
              option: {
                flag: any;
                name: string;
                alpha2Code: string;
                callingCode: string;
              },
              index
            ) => (
              <option key={index} value={option.callingCode}>
                {option.callingCode}
              </option>
            )
          )}
        </Select>
      </InputFieldWrapper>
    </>
  );
};

const InputFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;
const Select = styled.select`
  -webkit-appearance:none;
  background: url(${downArrow}) no-repeat; 
  background-position: right center;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 400;
  font-size: 0.75rem;
  line-height: 0.75rem;
  padding: 0.8rem 0.8rem 0.75rem 0;
  margin-right:1rem;
  border-radius: 0.25rem;
  border: 0rem;
  color: ${(props) => (props.value ? Colors.black : Colors.autumnFog)};
  :focus {
    outline: none;
  }
  > option {
    color: ${Colors.black};
  }
  > option:first-child {
    color: ${Colors.purplishGrey};
  }
  :disabled {
    background: ${Colors.white};
    color: ${Colors.cloudyGrey};
    cursor:no-drop;
  }
  }
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-style: normal;
  font-weight: 350;
  font-size: 0.75rem;
  line-height: 1rem;
  color: ${Colors.electricBlue};
  margin-bottom: 0.5rem;
  > span {
    color: ${Colors.red};
    margin-left: 0.125rem;
  }
`;

export default DropdownWithImage;
